import { FC, ReactNode } from 'react'
import {
  Container,
  Card,
  ImageContainer,
  CardContent
} from './styles'
import { LeftBar } from '../LeftBar'

import LightBulbImg from '../../../assets/lightbulb.svg'
import WarningImg from '../../../assets/warning.svg'

interface ReminderCardProps {
  children: ReactNode;
  title: string;
  withLeftBar?: boolean;
  icon: 'bulb' | 'warning';
}

const ReminderCard: FC<ReminderCardProps> = ({
  children,
  title,
  withLeftBar,
  icon
}) => {
  return (
    <Container>
      {!!withLeftBar ? <LeftBar /> : null}
      <Card>
        <ImageContainer>
          <img src={icon === 'bulb' ? LightBulbImg : WarningImg} alt="reminder" />
        </ImageContainer>
        <CardContent>
          <strong>{title}</strong>
          <span>{children}</span>
        </CardContent>
      </Card>
    </Container>
  )
}

export default ReminderCard